
<salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

<salonmonster-tap-retry *ngIf="anErrorOccuredWhileLoadingCommunicationHistory" (click)="onTapToReload()"></salonmonster-tap-retry>

<ion-list>
  <ion-card
    tappable
    *ngFor="let communication of history"
    (click)="viewCommunication(communication)"
    >
    <ion-card-header>
      <ion-icon name='mail' *ngIf="communication.communicationType == 'client_email' || communication.communicationType == 'bulk_email'"></ion-icon>
      <ion-title class='sm-clickable'>{{ communication.title }}</ion-title>
      <ion-icon class="sm-clickable" item-right name='arrow-forward'></ion-icon>
    </ion-card-header>
    <div class="ion-padding">
      <ion-icon name='checkmark' *ngIf='communication.status == 1'></ion-icon>
      <ion-icon name='close' color='danger' *ngIf='communication.status == 0'></ion-icon>
      {{ communication.datetime | salonMonsterDate: 'dddd, MMMM D, Y h:mm a' }}
    </div>
  </ion-card>
</ion-list>
